'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function FIFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-bqx045wdr", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-zn4ml8rtc", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-o1qg69c3o" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-o1qg69c3o", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-bqx045wdr)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-o1qg69c3o" }), /* @__PURE__ */ React.createElement("g", { fill: "#2e42a5", stroke: "#2e42a5", strokeWidth: "2", mask: "url(#mantine-zn4ml8rtc)" }, /* @__PURE__ */ React.createElement("path", { d: "M13.818 1v9.323H33v4H13.818V25h-4V14.323H-1v-4H9.818V1z" }))))
  );
}

export { FIFlag };
//# sourceMappingURL=FI.mjs.map
